import EditUser from './component'

export default EditUser
